var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    attrs: {
      placement: "right-start",
      title: "干系人",
      width: "200",
      trigger: "hover"
    },
    on: {
      show: _vm.init
    }
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c("ul", _vm._l(_vm.list, function (item) {
    return _c("li", {}, [_c("span", {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.c11Role) + ": ")]), _c("span", {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.c11Name))])]);
  }), 0)]), _c("span", {
    staticStyle: {
      cursor: "pointer"
    },
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      "is-iconfont": true,
      name: "duorenyonghu-"
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };